import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import "./project.css"

const ProjectNavigator = ({ projectList }) => {
  const { projectId } = useParams();
  const history = useHistory();

  const currentIndex = projectList.findIndex(id => id.toString() === projectId);

  if (currentIndex === -1) {
    return <div>Error: Project not found</div>;
  }

  const previousProject = projectList[(currentIndex - 1 + projectList.length) % projectList.length];
  const nextProject = projectList[(currentIndex + 1) % projectList.length];

  const onPrevious = () => history.push(`/projects/${previousProject}`);
  const onNext = () => history.push(`/projects/${nextProject}`);

  return (
    <div className="project-navigator content-center">
      <button className="button md:text-md text-sm" onClick={onPrevious}>Previous Project</button>
      <span> | </span>
      <button className="button md:text-md text-sm" onClick={onNext}>Next Project</button>
    </div>
  );
};

export default ProjectNavigator;
